import React from "react";
import { useTranslation } from "react-i18next";
import { isImageUrl } from "../../../../helpers/functions";
import { ReactComponent as IconCash } from "../../../../assets/icons/icon-cash.svg";
import { ReactComponent as IconBonus } from "../../../../assets/icons/icon-bonus.svg";
import { ReactComponent as IconTotal } from "../../../../assets/icons/icon-total.svg";
import clsx from "clsx";
import { FaUserCircle } from "react-icons/fa";
import { MdRefresh } from "react-icons/md";
import { t } from "i18next";

const UserBalance = ({ user, isMobileNav, isHeader }) => {
  const { t } = useTranslation();
  // const totalBalance = (user?.balance || 0) + (user?.sportsbookBonus || 0) + (user?.casinoBonus || 0);

  const userBalanceData = [
    {
      title: "Cash",
      image: <IconCash />,
      cash: user?.balance || 0,
    },
    {
      title: t("Sports Bonus"),
      image: <IconBonus />,
      cash: user?.sportsbookBonus || 0,
    },
    {
      title: t("Casino Bonus"),
      image: <IconBonus />,
      cash: user?.casinoBonus || 0,
    },
    // {
    //   title: "Total",
    //   image: <IconTotal />,
    //   cash: totalBalance,
    // },
  ];

  return (
    <>
      {isMobileNav && (
        <div className="flex  items-center gap-2 pb-4 px-4 border-b border-white/20">
          <FaUserCircle size={40} />
          <div className="flex flex-col text-[14px] ml-2">
            <span>{user?.username}</span>
            <span>{user?.role}</span>
          </div>
        </div>
      )}
      <div className="px-4">
        {userBalanceData
          .filter((fi) => (isHeader && !isMobileNav ? fi.title !== "Cash" : fi))
          .map((item, index) => {
            return (
              <span key={index} className={clsx("block py-1.5 text-sm text-white", isMobileNav && "border-b border-white/20 ")}>
                <div className="flex items-center gap-2 justify-between">
                  <ul>
                    <li className="flex items-center gap-2 ">{item.title}</li>
                  </ul>
                  <span>TND {item?.cash?.toFixed(2)}</span>
                </div>
              </span>
            );
          })}
      </div>
      {/* {isMobileNav && ( */}
      <div className="px-4 mt-3 mb-1">
        <button className={clsx(" border border-white rounded-xl py-1.5 w-full flex justify-center items-center gap-3 mb-2")}>
          <MdRefresh size={22} /> {t("Refresh")}
        </button>
      </div>
      {/* )} */}
    </>
  );
};

export default UserBalance;
